import styled from 'styled-components'

export const Heading1 = styled.h1``
